module.exports = __webpack_public_path__ + "img/2.ff7c8337.png";